var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.25 15c-.49728 0-.97419-.1975-1.32583-.5492-.35163-.3516-.54917-.8285-.54917-1.3258v-2.25c0-.4973-.19754-.97419-.54917-1.32583-.35164-.35163-.82855-.54917-1.32583-.54917.24623 0 .49005-.0485.71753-.14273.22749-.09422.43419-.23233.6083-.40644s.31222-.38081.40644-.6083c.09423-.22748.14273-.4713.14273-.71753v-2.25c0-.49728.19754-.97419.54917-1.32583.35164-.35163.82855-.54917 1.32583-.54917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.75 3c.4973 0 .9742.19754 1.3258.54917.3517.35164.5492.82855.5492 1.32583v2.25c0 .24623.0485.49005.1427.71753.0943.22749.2324.43419.4065.6083.3516.35163.8285.54917 1.3258.54917-.4973 0-.9742.19754-1.3258.54917-.3517.35164-.5492.82853-.5492 1.32583v2.25c0 .4973-.1975.9742-.5492 1.3258-.3516.3517-.8285.5492-1.3258.5492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.50664 9.06155c0-.00742-.0022-.01467-.00632-.02084-.00412-.00616-.00998-.01097-.01683-.01381s-.01439-.00358-.02167-.00213c-.00727.00145-.01395.00502-.0192.01026-.00524.00525-.00881.01193-.01026.0192-.00145.00728-.0007.01482.00213.02167.00284.00685.00765.01271.01382.01683.00616.00412.01341.00632.02083.00632.00492 0 .0098-.00097.01435-.00286.00455-.00188.00868-.00464.01217-.00812.00348-.00349.00624-.00762.00813-.01217.00188-.00455.00285-.00943.00285-.01435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.03789 9.05471c0-.00994-.00395-.01948-.01098-.02651-.00703-.00704-.01657-.01099-.02652-.01099-.00994 0-.01948.00395-.02652.01099-.00703.00703-.01098.01657-.01098.02651 0 .00995.00395.01949.01098.02652.00704.00703.01658.01098.02652.01098.00995 0 .01949-.00395.02652-.01098s.01098-.01657.01098-.02652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.2879 9.05471c0-.00994-.004-.01948-.011-.02651-.007-.00704-.0166-.01099-.0265-.01099-.01 0-.0195.00395-.0265.01099-.0071.00703-.011.01657-.011.02651 0 .00995.0039.01949.011.02652.007.00703.0165.01098.0265.01098.0099 0 .0195-.00395.0265-.01098s.011-.01657.011-.02652"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsFileIcon);
export default __webpack_public_path__ + "static/media/js-file-icon.b33580f54093ede9577caf738aa72ba0.svg";
export { ForwardRef as ReactComponent };